import React from 'react';  // eslint-disable-line

const Ban = () => {
    return (
        <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Revisions" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="publish-error-popover-more-human-copy" transform="translate(-1007.000000, -83.000000)" stroke="#111111">
                    <g id="ban" transform="translate(1007.000000, 83.000000)">
                        <circle id="Oval" cx="8" cy="8" r="7.5" />
                        <path d="M2.697,13.303 L13.303,2.697" id="Shape" />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default Ban;
